export default __webpack_public_path__ + "static/Prometheus-38784ddbf29dd6e7e1c2ecb9fd5e43ba.webp";